export default __webpack_public_path__ + "static/media/learn.c1957735.svg";